<template>
  <div class="card">
    <div class="my-2 px-2">
      <DateQuerySetter
        btnTitle="Go"
        @onClickGo="onClickGo"
      >
        <div class="col-12 col-sm-6 col-md-3 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Party: </label>
          <AsyncSelect
            placeholder="Party Name, ID, Mobile No"
            :api-service="fetchContactProfiles"
            :reduce="(name) => name.id"
            v-model="contactProfileId"
            :additional-query="{type: 'customer'}"
            :format-label="formatPatientLabel"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Status</label>
          <v-select
              placeholder="Select Status"
              v-model="selectedOrderStatus"
              :options="orderStatuses"
              label="name"
              :reduce="option => option.value"
          />
        </div>
      </DateQuerySetter>
    </div>
    <div class="col-12 px-2 mt-2">
      <div class="card">
        <div class="table-responsive"  style="min-height: 400px">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th>#SL</th>
              <th>Customer Details</th>
              <th>Order Number</th>
              <th>Order Date</th>
              <th class="text-right">Order Amount</th>
              <th>Invoice No</th>
              <th>Invoice Date</th>
              <th class="text-right">Invoice Amount</th>
              <th class="text-center">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in purchaseList.data" :key="i" style="cursor: pointer">
              <td> {{ (purchaseList.current_page - 1) * (purchaseList.per_page) + (i + 1) }}</td>
              <td> {{ item.party_name }} ({{ item.contact.company_roles && item.contact.company_roles[0] ? item.contact.company_roles[0].pivot.serial_no : ''}})</td>
              <td>
                <span>{{ item.bill_number }}</span>
              </td>
              <td> {{ item.date }}</td>
              <td class="text-right"> {{ item.bill_amount }}</td>
              <td>
                <span v-if="item.sale_master_id">{{ item.sale_master_bill_number }}</span>
              </td>
              <td>
                <span v-if="item.sale_master_id">{{ item.sale_master_date }}</span>
              </td>
              <td class="text-right">
                <span v-if="item.sale_master_id">{{ item.sale_master_total_amount }}</span>
              </td>
              <td class="text-center">
                <div class="btn-group">
                  <div v-if="item.status != 'cancelled'">
                    <button @click="goToOrderPage(item)" title v-if="!item.sale_master_id" class="btn btn-outline-primary btn-sm ml-5">
                      <i class="fas fa-pencil-alt"></i>
                    </button>

                    <button @click="goToInvoice(item)" title v-if="!item.sale_master_id" class="btn btn-outline-primary btn-sm mx-1">
                      <i class="fas fa-plus"></i>
                      Invoice
                    </button>
                  </div>
                  <button v-if="!item.sale_master_id && item.status === 'active'" class="btn btn-outline-danger btn-sm ml-5"
                          @click="updateStatus(item.id, 'cancelled')"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                  <button v-if="!item.sale_master_id && item.status === 'cancelled'" class="btn btn-outline-success btn-sm ml-5"
                          @click="updateStatus(item.id, 'active')"
                  >
                    Active
                  </button>
                </div>
              </td>
            </tr>

            </tbody>
          </table>
          <p v-if="purchaseList && purchaseList.data && !purchaseList.data.length" class="text-center mt-5">No data</p>
        </div>
      </div>

    </div>
    <div class="px-2"><Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/></div>
  </div>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import { ref, inject, onMounted, computed  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import Pagination from '@/components/atom/Pagination'
import handleContact from "@/services/modules/contact";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";

const router = useRouter()
const store = useStore()
let offset = ref(20)
let purchaseList = ref([])
let contactProfileId = ref(null)
const route = useRoute()
const selectedOrderStatus = ref(null);
const orderStatuses = ref([]);
const showError = inject("showError");
const showSuccess = inject("showSuccess");

const { fetchSalesOrderList, updateOrderStatus, fetchOrderStatus } = handlePurchase()
const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper()

const companyId = computed(() => {
  return route.params.companyId
})
const startDate = computed(() => {
  return route.query.start
})
const endDate = computed(() => {
  return route.query.end
})
const page = computed(() => {
  return route.query.page
})

function getQuery () {
  let query = '?company_id=' + companyId.value + '&is_hide_invoice=true'
  if(!!contactProfileId.value) query += '&contact_profile_id='+contactProfileId.value
  if(selectedOrderStatus.value) query += '&status='+selectedOrderStatus.value
  if(!startDate.value && !endDate.value) return query
  if(startDate.value) query += '&start_date='+startDate.value
  if(endDate.value) query += '&end_date='+endDate.value
  if(page.value) query += '&page='+page.value
  query += '&offset='+offset.value
  return query
}

const getOrderStatus = async () => {
  const res = await fetchOrderStatus('?company_id=' + companyId.value);
  if (res.status) {
    orderStatuses.value = res.data.filter(item => ['pending', 'approved', 'cancelled', 'active'].includes(item.value))
  }
}

function onClickGo() {
  fetchSalesOrderList(getQuery())
    .then(res => {
      if(! res.status) {
        purchaseList.value = []
        store.commit("resetPagination")
        return
      }
      purchaseList.value = res.date
      setPagination(res.date)
    })
}

const updateStatus = async (id, status) => {
  const actionText = status === 'cancelled' ? 'cancel' : 'activate';
  if (! confirm(`Are you sure you want to ${actionText} this order?`)) return;

  const companyQuery = `?company_id=${companyId.value}&status=${status}`;

  await updateOrderStatus(companyQuery, id).then( async (res) => {
    if(! res.status) {
      showError(res.message);
      return
    }
    showSuccess(res.message);
    onClickGo()
  }).catch( (err) => {
    console.log("Something went wrong");
  })
}

function setPagination(data) {
  if(!data.data.length) return
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) =>  {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await onClickGo()
}

const goToInvoice = (item) => {
  router.push({
    name: 'pos-invoice',
    params: route.params,
    query: {
      ...route.query,
      sales_order_id: item.id,
      selected_tab: 'pos'
    }
  })
}

const goToOrderPage = (item) => {
  router.push({
    name: 'pos-invoice',
    params: route.params,
    query: {
      ...route.query,
      order_sales_id: item.id,
      selected_tab: 'order'
    }
  })
}

onMounted(() => {
  onClickGo()
  getOrderStatus()
})

</script>
